export default __webpack_public_path__ + "static/media/11.b6025146.jpg";